<template>
  <div class="templates-page">

    <h1>{{ $t('templates.title') }}</h1>

    <!-- TOAST -->
    <transition name="fade">
      <div v-if="toast.show" class="toast">
        {{ toast.message }}
      </div>
    </transition>

    <!-- CREATE -->
    <div class="card">
      <h3>{{ $t('templates.create') }}</h3>

      <input v-model="form.name" placeholder="Template name" />

      <select v-model="form.type">
        <option value="email">Email</option>
        <option value="sms">SMS</option>
      </select>

      <input v-if="form.type === 'email'" v-model="form.subject" placeholder="Subject" />

      <textarea v-model="form.content" rows="5" placeholder="Message content" />

      <button @click="createTemplate">
        {{ $t('actions.create') }}
      </button>
    </div>

    <!-- LIST -->
    <div class="card">
      <h3>{{ $t('templates.list') }}</h3>

      <div v-for="tpl in templates" :key="tpl.id" class="template-item">

        <div>
          <strong>{{ tpl.name }}</strong>
          <small>{{ tpl.type }}</small>
        </div>

        <div class="actions">
          <button @click="editTemplate(tpl)">
            {{ $t('actions.edit') }}
          </button>

          <button @click="deleteTemplate(tpl.id)">
            {{ $t('actions.delete') }}
          </button>
        </div>

      </div>
    </div>

    <!-- EDIT -->
    <div v-if="editing" class="card">
      <h3>{{ $t('templates.edit') }}</h3>

      <input v-model="editing.name" />

      <input v-if="editing.type === 'email'" v-model="editing.subject" />

      <textarea v-model="editing.content" rows="5" />

      <button @click="updateTemplate">
        {{ $t('actions.save') }}
      </button>
    </div>

  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import * as api from '@/services/api.js'

/* STATE */
const templates = ref([])
const editing = ref(null)

const form = reactive({
  name: '',
  type: 'email',
  subject: '',
  content: ''
})

/* TOAST */
const toast = reactive({ show: false, message: '' })
const showToast = (m) => {
  toast.message = m
  toast.show = true
  setTimeout(() => (toast.show = false), 3000)
}

/* LOAD */
onMounted(loadTemplates)

async function loadTemplates() {
  try {
    templates.value = await api.templates.getAll()
  } catch (err) {
    console.error(err)
  }
}

/* CREATE */
async function createTemplate() {
  try {
    await api.templates.create(form)
    showToast('Created')
    Object.assign(form, { name: '', subject: '', content: '' })
    loadTemplates()
  } catch (err) {
    console.error(err)
    showToast('Error')
  }
}

/* EDIT */
function editTemplate(tpl) {
  editing.value = { ...tpl }
}

/* UPDATE */
async function updateTemplate() {
  try {
    await api.templates.update(editing.value.id, editing.value)
    showToast('Updated')
    editing.value = null
    loadTemplates()
  } catch (err) {
    console.error(err)
    showToast('Error')
  }
}

/* DELETE */
async function deleteTemplate(id) {
  try {
    await api.templates.delete(id)
    showToast('Deleted')
    loadTemplates()
  } catch (err) {
    console.error(err)
  }
}
</script>

<style scoped>
.templates-page {
  max-width: 900px;
  margin: auto;
  padding: 30px;
  background: white;
}

.card {
  border: 1px solid #eee;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
}

.template-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.actions {
  display: flex;
  gap: 10px;
}

button {
  padding: 8px 12px;
  background: #4f46e5;
  color: white;
  border-radius: 8px;
}

.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #22c55e;
  color: white;
  padding: 10px;
}
</style>